/**
 * OC AI Loading Message Component
 * Wrapper around AILoadingMessage that gets configuration from OcFabWidgetOptions context
 * This is the default loading message for OC widgets
 */

import { FC } from 'react';

import AILoadingMessage from '../../../AiAvatar/AILoadingMessage';
import { useOcFabWidgetOptions } from '../../contexts/OcFabWidgetOptionsContext';

/**
 * OCAILoadingMessage Component
 * 
 * Displays during chat loading or awaiting server response states
 * If a custom loadingMessage is provided in context, it renders that
 * Otherwise, it renders the default AILoadingMessage with assistant name and avatar from context
 */
export const OCAILoadingMessage: FC = () => {
    const { assistantName, avatarUrl, loadingMessage } = useOcFabWidgetOptions();

    // If a custom loading message is provided, use it
    if (loadingMessage) {
        return <>{loadingMessage}</>;
    }

    // Otherwise, use the default loading message
    return (
        <AILoadingMessage
            assistantName={assistantName}
            avatarUrl={avatarUrl}
        />
    );
};

export default OCAILoadingMessage;

